let getSiblings = function (elem) {
  const siblings = [];
  let sibling = elem.parentNode.firstChild;
  for (; sibling; )
    sibling.nodeType === 1 && sibling !== elem && siblings.push(sibling),
      (sibling = sibling.nextSibling);
  return siblings;
};

let slideUp = (target, duration = 500) => {
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.boxSizing = "border-box";
  target.style.height = target.offsetHeight + "px";
  target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(() => {
    target.style.display = "none";
    target.style.removeProperty("height");
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
    //alert("!");
  }, duration);
};

/* SLIDE DOWN */
let slideDown = (target, duration = 500) => {
  target.style.removeProperty("display");
  let display = window.getComputedStyle(target).display;
  if (display === "none") display = "block";
  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = "border-box";
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.height = height + "px";
  target.style.removeProperty("padding-top");
  target.style.removeProperty("padding-bottom");
  target.style.removeProperty("margin-top");
  target.style.removeProperty("margin-bottom");
  window.setTimeout(() => {
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
};

function TopOffset(el) {
  let rect = el.getBoundingClientRect(),
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop };
}

/* TOOGLE */
var slideToggle = (target, duration = 500) => {
  if (window.getComputedStyle(target).display === "none") {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
};

const thumnailContainer = document.querySelector(".vertical-thubnails");
if (thumnailContainer != null) {
  const main_image = document.querySelector(
    ".slider-main-wrapper .product__media-item.is-active"
  );
  thumnailContainer.style.height = main_image.clientHeight + "px";
}

class Stickybar extends HTMLElement {
  constructor() {
    super();
    this.sticky_close = this.querySelector(".sticky-product__close");
    this.sticky_close.addEventListener("click", this.closeSticky.bind(this));
  }
  connectedCallback() {
    this.initSticky();
  }

  closeSticky() {
    this.remove();
  }
  initSticky() {
    const productForm = document.querySelector(".product-form"),
      productStickyWrapper = document.querySelector(".sticky-product");
    window.addEventListener("scroll", function () {
      let productFormTopffset = TopOffset(productForm).top;
      window.scrollY > productFormTopffset
        ? (productStickyWrapper.classList.add("sticky"),
          document.body.classList.add("sticky__cart"))
        : (productStickyWrapper.classList.remove("sticky"),
          document.body.classList.remove("sticky__cart"));
    });
  }
}
customElements.define("sticky-component", Stickybar);

class TabsGroup extends HTMLElement {
  constructor() {
    super();
    this.tabsToggle = this.querySelectorAll(".tabs li");
    this.nav = this.tab
      ? null
      : Array.from(this.querySelectorAll(".button-tab"));
    this.tabPanels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.content_item = Array.from(this.querySelectorAll(".tab-content__item"));
    this.accordiaonTabToggle = this.querySelectorAll(".accordion__item-tab");
    this.currentNav = this.querySelector(".tabs li.active");
    window.addEventListener("resize", this.windowSize.bind(this));
  }
  connectedCallback() {
    if (this.accordiaonTabToggle != null) {
      this.accordionTab();
    }
    if (this.tabsToggle != null && this.tabPanels != null) {
      this.tabClickHandler();
    }
  }

  windowSize() {
    if (window.innerWidth > 768) {
      if (this.tabPanels != null) {
        [].forEach.call(this.tabPanels, function (pane, index) {
          pane.classList.remove("active");
          pane.setAttribute("style", "");
        });
        this.id = this.querySelector(
          '.tabs li.active button[type="button"]'
        ).getAttribute("id");
        const currentTab = this.tabPanels.find(
          (panel) => panel.getAttribute("aria-labelledby") === this.id
        );
        currentTab.parentNode.classList.add("active");
        currentTab.classList.add("active");
      }
    }
  }

  tabClickHandler() {
    let tablist = this.tabsToggle;
    let tabPanels = this.tabPanels;
    let content_items = this.content_item;

    this.tabsToggle.forEach(function (list) {
      list.addEventListener("click", function (e) {
        tablist.forEach(function (label, index) {
          label.classList.remove("active");
        });

        [].forEach.call(tabPanels, function (pane, index) {
          pane.classList.remove("active");
          pane.setAttribute("style", "");
        });

        [].forEach.call(content_items, function (item, index) {
          item.classList.remove("active");
        });

        e.currentTarget.classList.add("active");
        const { id } = e.currentTarget.querySelector(".button-tab");

        const currentTab = tabPanels.find(
          (panel) => panel.getAttribute("aria-labelledby") === id
        );
        currentTab.parentNode.classList.add("active");
        currentTab.classList.add("active");
      });
    });
  }

  accordionTab(e) {
    let tablist = this.tabsToggle;
    let navlist = this.nav;
    this.accordiaonTabToggle.forEach(function (list) {
      list.addEventListener("click", function (event) {
        tablist.forEach(function (label, index) {
          label.classList.remove("active");
        });

        let singleFaqItem = list.closest(".tab-content__item");
        let singleFaqItemBody = singleFaqItem.querySelector(".tab-contents");

        const { id } = singleFaqItem.querySelector(".accordion__item-tab");
        const currentNav = navlist.find(
          (panel) => panel.getAttribute("aria-controls") === id
        );

        currentNav.parentNode.classList.add("active");

        singleFaqItem.addEventListener(
          "transitionend",
          () => {
            trapFocus(singleFaqItem);
          },
          { once: !0 }
        );
        singleFaqItem.addEventListener("keyup", (evt) => {
          evt.code === "Escape" &&
            (singleFaqItem.classList.remove("active"),
            slideUp(singleFaqItemBody),
            removeTrapFocus(singleFaqItem));
        });
        singleFaqItem.classList.contains("active")
          ? (singleFaqItem.classList.remove("active"),
            slideUp(singleFaqItemBody))
          : (singleFaqItem.classList.add("active"),
            slideDown(singleFaqItemBody),
            getSiblings(singleFaqItem).forEach(function (list2) {
              let sibllingSingleAccordionBody =
                list2.querySelector(".tab-contents");
              list2.classList.remove("active"),
                slideUp(sibllingSingleAccordionBody);
            }));
      });
    });
  }
}

customElements.define("tabs-group", TabsGroup);

const initSectionVisiable = function (elemnts) {
  new IntersectionObserver(
    (entries, observer2) => {
      entries.forEach((entry) => {
        entry.isIntersecting &&
          typeof elemnts.callback == "function" &&
          (elemnts.callback(), observer2.unobserve(entry.target));
      });
    },
    { rootMargin: `0px 0px ${elemnts.margin}px 0px` }
  ).observe(elemnts.element);
};

customElements.get("marquee-scroll") ||
  customElements.define(
    "marquee-scroll",
    class extends HTMLElement {
      constructor() {
        super(),
          (this.scrolling = this.querySelector(".scrolling--item")),
          initSectionVisiable({
            element: this,
            callback: this.initScroll.bind(this),
            margin: 300,
          });
      }
      initScroll() {
        if (this.childElementCount === 1) {
          this.scrolling.classList.add("scrolling--animated");
          for (let i = 0; i < 10; i++)
            (this.clone = this.scrolling.cloneNode(!0)),
              this.clone.setAttribute("aria-hidden", !0),
              this.appendChild(this.clone);
          new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                entry.isIntersecting
                  ? this.classList.remove("scrolling--text--paused")
                  : this.classList.add("scrolling--text--paused");
              });
            },
            {
              rootMargin: "0px 0px 50px 0px",
            }
          ).observe(this);
        }
      }
    }
  );

class gridButtons extends HTMLElement {
  constructor() {
    super();
    this.girColumnWrapper = document.querySelector("#ProductGridContainer");
    this.gridColumnButtons = this.querySelectorAll(".gird__column_icon");
    this.girColumnWrapperClssList = this.girColumnWrapper.classList;
  }
  connectedCallback() {
    if (this.gridColumnButtons != null) {
      this.productGrid();
    }
  }

  productGrid() {
    let gridClassName = localStorage.getItem("gridColumn");
    let girColumnWrapperClssList = this.girColumnWrapper.classList;

    gridClassName &&
      (this.girColumnWrapper.classList.remove(
        "grid-col-2",
        "grid-col-3",
        "grid-col-4"
      ),
      this.girColumnWrapper.classList.add(gridClassName)),
      this.gridColumnButtons.forEach((singleItem) => {
        if (gridClassName)
          switch (gridClassName) {
            case "grid-col-2":
              singleItem.classList.contains("product_col_two") &&
                (singleItem.classList.add("active"),
                getSiblings(singleItem).forEach(function (item) {
                  item.classList.remove("active");
                }));
              break;
            case "grid-col-3":
              singleItem.classList.contains("product_col_three") &&
                (singleItem.classList.add("active"),
                getSiblings(singleItem).forEach(function (item) {
                  item.classList.remove("active");
                }));
              break;
            default:
              singleItem.classList.contains("product_col_four") &&
                (singleItem.classList.add("active"),
                getSiblings(singleItem).forEach(function (item) {
                  item.classList.remove("active");
                }));
          }
        singleItem.addEventListener("click", (event) => {
          singleItem.classList.add("active"),
            getSiblings(singleItem).forEach(function (item) {
              item.classList.remove("active");
            }),
            singleItem.classList.contains("product_col_two")
              ? (localStorage.setItem("gridColumn", "grid-col-2"),
                (gridClassName = localStorage.getItem("gridColumn")),
                this.girColumnWrapper.classList.add(gridClassName),
                (girColumnWrapperClssList.contains("grid-col-5") ||
                  girColumnWrapperClssList.contains("grid-col-4") ||
                  girColumnWrapperClssList.contains("grid-col-3") ||
                  girColumnWrapperClssList.contains("grid-col-1")) &&
                  this.girColumnWrapper.classList.remove(
                    "grid-col-5",
                    "grid-col-4",
                    "grid-col-3",
                    "grid-col-1"
                  ))
              : singleItem.classList.contains("product_col_three")
              ? (localStorage.setItem("gridColumn", "grid-col-3"),
                (gridClassName = localStorage.getItem("gridColumn")),
                this.girColumnWrapper.classList.add(gridClassName),
                (girColumnWrapperClssList.contains("grid-col-5") ||
                  girColumnWrapperClssList.contains("grid-col-4") ||
                  girColumnWrapperClssList.contains("grid-col-2") ||
                  girColumnWrapperClssList.contains("grid-col-1")) &&
                  this.girColumnWrapper.classList.remove(
                    "grid-col-5",
                    "grid-col-4",
                    "grid-col-2",
                    "grid-col-1"
                  ))
              : singleItem.classList.contains("product_col_four") &&
                (localStorage.setItem("gridColumn", "grid-col-4"),
                (gridClassName = localStorage.getItem("gridColumn")),
                this.girColumnWrapper.classList.add(gridClassName),
                (girColumnWrapperClssList.contains("grid-col-5") ||
                  girColumnWrapperClssList.contains("grid-col-3") ||
                  girColumnWrapperClssList.contains("grid-col-2") ||
                  girColumnWrapperClssList.contains("grid-col-1")) &&
                  this.girColumnWrapper.classList.remove(
                    "grid-col-5",
                    "grid-col-3",
                    "grid-col-2",
                    "grid-col-1"
                  ));
        });
      });
  }
}

customElements.define("grid-buttons", gridButtons);

class BeforeAfterImages extends HTMLElement {
  constructor() {
    super(),
      (this.$ = this.querySelector.bind(this)),
      (this.$$ = this.querySelectorAll.bind(this)),
      this.init();
  }
  connectedCallback() {
    this.observeResize();
  }
  observeResize() {
    (this.resizeObserver = new ResizeObserver(() => this.init())),
      this.resizeObserver.observe(this.afterImage);
  }
  init() {
    (this.afterImage = this.$(".js-after-image")),
      (this.splitCusor = this.$(".js-split-cursor")),
      (this.imageWith = this.afterImage.offsetWidth),
      (this.imageHeight = this.afterImage.offsetHeight),
      (this.isClicked = !1),
      this.handleEvent();
  }
  handleEvent() {
    this.splitCusor.addEventListener("mousedown", this.slideReady.bind(this), {
      passive: !0,
    }),
      this.splitCusor.addEventListener(
        "touchstart",
        this.slideReady.bind(this),
        { passive: !0 }
      ),
      this.splitCusor.addEventListener("mouseup", this.slideFinish.bind(this), {
        passive: !0,
      }),
      this.splitCusor.addEventListener(
        "touchend",
        this.slideFinish.bind(this),
        { passive: !0 }
      );
  }
  slideReady(t) {
    (this.isClicked = !0),
      document.addEventListener("mousemove", this.slideMove.bind(this)),
      document.addEventListener("touchmove", this.slideMove.bind(this));
  }
  slideFinish(t) {
    (this.isClicked = !1),
      document.removeEventListener("mousemove", this.slideMove.bind(this)),
      document.removeEventListener("touchmove", this.slideMove.bind(this));
  }
  slideMove(t) {
    var e;
    this.isClicked &&
      ((e = this.offsetLeft),
      (t = (t = t.changedTouches ? t.changedTouches[0] : t).clientX - e),
      (this.posSplitCusor = (t / this.imageWith) * 100),
      (this.posSplitCusor = Math.min(100, Math.max(0, this.posSplitCusor))),
      requestAnimationFrame(() => {
        this.style.setProperty(
          "--before-after-initial-drag-position",
          this.posSplitCusor + "%"
        );
      }));
  }
}

customElements.define("before-after-images", BeforeAfterImages);

class slideshowSwiper extends HTMLElement {
  constructor() {
    super();
    this.slider;
    this.resizeObserver;
    window.addEventListener("resize", this.handleResize.bind(this));
  }

  connectedCallback() {
    this.sliderWrapper = this.querySelector(".slideshow__swiper");
    this.optionsData = this.sliderWrapper.dataset.option
      ? JSON.parse(this.sliderWrapper.dataset.option)
      : {};
    this.desktopslider = this.optionsData.desktopSlider;
    this.grid = this.optionsData.grid;
    this.resizeObserver = new ResizeObserver((entries) => this.initials());
    this.resizeObserver.observe(this.sliderWrapper);
  }

  initials() {
    if (this.desktopslider == false) {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
      if (window.innerWidth < 768) {
        this.initSlider();
      }
    } else {
      this.initSlider();
    }
  }

  initSlider() {
    let next = this.querySelector(".swiper-button-next");
    let prev = this.querySelector(".swiper-button-prev");
    let pagination = this.querySelector(".swiper-pagination");
    let scrollbar = this.querySelector(".swiper-scrollbar");

    let defaults = {
      effect: "slide",
      slidesPerView: "auto",
      centeredSlides: false,
      grabCursor: false,
      horizontal: true,
      watchSlidesProgress: true,
      draggable: !0,
      autoHeight: !1,
      watchOverflow: !0,
      threshold: 10,
      speed: 700,
      freeMode: false,
      loop: false,
      autoplay: {
        enabled: false,
        disableOnInteraction: false,
        delay: 1500,
      },
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      scrollbar: {
        el: scrollbar,
        draggable: true,
      },
      pagination: {
        el: pagination,
        clickable: true,
        renderBullet: function (index, className) {
          return (
            '<span class="' +
            className +
            ' swiper-pagination-bullet--svg-animation"><svg width="28" height="28" viewBox="0 0 28 28"><circle class="svg__circle" cx="14" cy="14" r="10" fill="none" stroke-width="2"></circle><circle class="svg__circle-inner" cx="14" cy="14" r="2" stroke-width="3"></circle></svg></span>'
          );
        },
      },
    };

    let options = { ...defaults, ...this.optionsData };

    this.slider = new Swiper(this.sliderWrapper, options);
  }

  handleResize() {
    this.initials();
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this.sliderWrapper);
    }
    if (this.slider) {
      this.slider.destroy(true, true);
    }
  }
}

customElements.define("slideshow-swiper", slideshowSwiper);

class GridSwiper extends HTMLElement {
  constructor() {
    super();
    this.slider;
    this.resizeObserver;
    window.addEventListener("resize", this.handleResize.bind(this));
  }

  connectedCallback() {
    this.sliderWrapper = this.querySelector(".gridSlide__swiper");
    this.optionsData = this.sliderWrapper.dataset.option
      ? JSON.parse(this.sliderWrapper.dataset.option)
      : {};
    this.desktopslider = this.optionsData.desktopSlider;
    this.grid = this.optionsData.grid;
    this.resizeObserver = new ResizeObserver((entries) => this.initials());
    this.resizeObserver.observe(this.sliderWrapper);
  }

  initials() {
    if (this.desktopslider == false) {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
      if (window.innerWidth < 768) {
        this.initSlider();
      }
    } else {
      this.initSlider();
    }
  }

  initSlider() {
    let next = this.querySelector(".swiper-button-next");
    let prev = this.querySelector(".swiper-button-prev");
    let pagination = this.querySelector(".swiper-pagination");
    let scrollbar = this.querySelector(".swiper-scrollbar");

    let defaults = {
      effect: "slide",
      slidesPerView: "auto",
      centeredSlides: false,
      grabCursor: false,
      horizontal: true,
      watchSlidesProgress: true,
      draggable: !0,
      autoHeight: !1,
      watchOverflow: !0,
      threshold: 10,
      speed: 700,
      freeMode: false,
      loop: false,
      grid: {
        rows: 2,
      },
      autoplay: {
        enabled: false,
        disableOnInteraction: false,
        delay: 1500,
      },
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      scrollbar: {
        el: scrollbar,
        draggable: true,
      },
      pagination: {
        el: pagination,
        clickable: true,
        renderBullet: function (index, className) {
          return (
            '<span class="' +
            className +
            ' swiper-pagination-bullet--svg-animation"><svg width="28" height="28" viewBox="0 0 28 28"><circle class="svg__circle" cx="14" cy="14" r="10" fill="none" stroke-width="2"></circle><circle class="svg__circle-inner" cx="14" cy="14" r="2" stroke-width="3"></circle></svg></span>'
          );
        },
      },
    };

    let options = { ...defaults, ...this.optionsData };

    this.slider = new Swiper(this.sliderWrapper, options);
  }

  handleResize() {
    this.initials();
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this.sliderWrapper);
    }
    if (this.slider) {
      this.slider.destroy(true, true);
    }
  }
}

customElements.define("grid-slider", GridSwiper);

function buildAnimation() {
  const buttons = gsap.utils.toArray(".button");

  if (buttons != null) {
    buttons.forEach((item) => {
      let span = item.querySelector(".button--text");
      let tl = gsap.timeline({ paused: true });
      if (span != null) {
        tl.to(span, { duration: 0.2, yPercent: -150, ease: "power2.in" });
        tl.set(span, { yPercent: 150 });
        tl.to(span, { duration: 0.2, yPercent: 0 });
        item.addEventListener("mouseenter", () => tl.play(0));
        item.addEventListener("mouseleave", () => tl.reverse());
      }
    });
  }

  const prev_button = gsap.utils.toArray(
    ".swiper-button-prev, .slider-button--prev"
  );
  const next_button = gsap.utils.toArray(
    ".swiper-button-next, .slider-button--next, .flash-icon"
  );

  if (next_button != null) {
    next_button.forEach((item) => {
      let span = item.querySelector("svg");
      let tl = gsap.timeline({ paused: true });
      if (span != null) {
        tl.to(span, { duration: 0.2, xPercent: 150, ease: "power2.in" });
        tl.set(span, { xPercent: -150 });
        tl.to(span, { duration: 0.2, xPercent: 0 });
        item.addEventListener("mouseenter", () => tl.play(0));
        item.addEventListener("mouseleave", () => tl.reverse());
      }
    });
  }

  if (prev_button != null) {
    prev_button.forEach((item) => {
      let span = item.querySelector("svg");
      let tl = gsap.timeline({ paused: true });
      if (span != null) {
        tl.to(span, { duration: 0.2, xPercent: -150, ease: "power2.in" });
        tl.set(span, { xPercent: 150 });
        tl.to(span, { duration: 0.2, xPercent: 0 });
        item.addEventListener("mouseenter", () => tl.play(0));
        item.addEventListener("mouseleave", () => tl.reverse());
      }
    });
  }

  const flash_sale = gsap.utils.toArray(".flash-sale");

  if (flash_sale != null) {
    flash_sale.forEach((item) => {
      let span = item.querySelector("svg");
      let tl = gsap.timeline({ paused: true });
      if (span != null) {
        tl.to(span, { duration: 0.3, xPercent: 150, ease: "power2.in" });
        tl.set(span, { xPercent: -150 });
        tl.to(span, { duration: 0.3, xPercent: 0 });
        item.addEventListener("mouseenter", () => tl.play(0));
        item.addEventListener("mouseleave", () => tl.reverse());
      }
    });
  }

  const icon_box = gsap.utils.toArray(".icon-item");

  if (icon_box != null) {
    icon_box.forEach((item) => {
      let span = item.querySelector("svg"),
        tl = gsap.timeline({ paused: true });
      tl.staggerTo(span, 0.2, { rotationY: 180 }, 0.3);
      item.addEventListener("mouseenter", () => tl.play(0));
      item.addEventListener("mouseleave", () => tl.reverse());
    });
  }

  const collection = gsap.utils.toArray(".collection__item  a");

  if (collection != null) {
    collection.forEach((item) => {
      let span = item.querySelector(".title--text");
      let tl = gsap.timeline({ paused: true });
      if (span != null) {
        tl.to(span, { duration: 0.2, yPercent: -150, ease: "power2.in" });
        tl.set(span, { yPercent: 150 });
        tl.to(span, { duration: 0.2, yPercent: 0 });
        item.addEventListener("mouseenter", () => tl.play(0));
        item.addEventListener("mouseleave", () => tl.reverse());
      }
    });
  }
}
buildAnimation();

document.addEventListener("shopify:section:load", function (event) {
  buildAnimation();
});

class swiperButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.buildAnimation();
  }

  buildAnimation() {
    const prev_button = gsap.utils.toArray(".swiper-button-prev");
    const next_button = gsap.utils.toArray(".swiper-button-next");

    if (next_button != null) {
      next_button.forEach((item) => {
        let span = item.querySelector("svg");
        let tl = gsap.timeline({ paused: true });
        if (span != null) {
          tl.to(span, { duration: 0.2, xPercent: 150, ease: "power2.in" });
          tl.set(span, { xPercent: -150 });
          tl.to(span, { duration: 0.2, xPercent: 0 });
          item.addEventListener("mouseenter", () => tl.play(0));
          item.addEventListener("mouseleave", () => tl.reverse());
        }
      });
    }

    if (prev_button != null) {
      prev_button.forEach((item) => {
        let span = item.querySelector("svg");
        let tl = gsap.timeline({ paused: true });
        if (span != null) {
          tl.to(span, { duration: 0.2, xPercent: -150, ease: "power2.in" });
          tl.set(span, { xPercent: 150 });
          tl.to(span, { duration: 0.2, xPercent: 0 });
          item.addEventListener("mouseenter", () => tl.play(0));
          item.addEventListener("mouseleave", () => tl.reverse());
        }
      });
    }
  }
}

customElements.define("swiper-button", swiperButton);

// VIDEO SECTION CODE

class TessaLoadMedia extends HTMLElement {
  constructor() {
    super(),
      (this.$ = this.querySelector.bind(this)),
      (this.sectionID = this.dataset.sectionId),
      (this.idVideo = this.dataset.idVideo),
      (this.typeVideo = this.dataset.type),
      (this.eleVideo = `shtVideo-${this.sectionID}-` + this.idVideo),
      (this.onPlayerStateYTChange = this.onPlayerStateYTChange.bind(this)),
      (this.onPlayerPlay = this.onPlayerPlay.bind(this)),
      (this.trigger = this.$(".js-load-media-trigger")),
      this.trigger &&
        this.trigger.addEventListener("click", this.handlePlayVideo.bind(this));
  }
  handlePlayVideo() {
    this.classList.add("playing");
    this.loadContent();
    const t = this.querySelector(".js-media-item-video");
    t &&
      t.addEventListener("play", () => {
        this.pauseAllVideo(t), t.play();
      });
  }
  onYouTubeIframeAPIReady() {
    if ("undefined" != typeof YT && void 0 !== YT.Player)
      try {
        this.player = new YT.Player(this.eleVideo, {
          videoId: this.idVideo,
          playerVars: { playsinline: 1 },
          events: {
            onReady: this.onPlayerYTReady,
            onStateChange: this.onPlayerStateYTChange,
          },
        });
      } catch (t) {
        console.error("Lỗi khi tạo trình phát YouTube:", t);
      }
    else {
      var t = document.createElement("script"),
        e =
          ((t.src = "https://www.youtube.com/iframe_api"),
          (t.onload = () => {
            this.onYouTubeIframeAPIReady();
          }),
          document.getElementsByTagName("script")[0]);
      e.parentNode.insertBefore(t, e);
    }
  }
  onVimeoIframeAPIReady() {
    if ("undefined" != typeof Vimeo && void 0 !== Vimeo.Player)
      try {
        var t = { id: this.idVideo, autoplay: 1 };
        (this.playerVimeo = new Vimeo.Player(this.eleVideo, t)),
          this.playerVimeo.on("play", () => {
            this.pauseAllVideo(this.playerVimeo);
          });
      } catch (t) {
        console.error("Lỗi khi tạo trình phát Vimeo:", t);
      }
    else {
      var t = document.createElement("script"),
        e =
          ((t.src = "https://player.vimeo.com/api/player.js"),
          (t.onload = () => {
            this.onVimeoIframeAPIReady();
          }),
          document.getElementsByTagName("script")[0]);
      e.parentNode.insertBefore(t, e);
    }
  }
  onPlayerYTReady = () => {
    this.pauseAllVideo(this.player), this.player.playVideo();
  };
  onPlayerStateYTChange = (t) => {
    1 == t.data && this.onPlayerPlay();
  };
  onPlayerPlay = () => {
    this.pauseAllVideo(this.player);
  };
  loadContent() {
    if (!this.getAttribute("loaded")) {
      if (this.$("template")) {
        var t = this.$("template").content.firstElementChild.cloneNode(!0);
        this.appendChild(t),
          this.isLoaded(!0),
          this.trigger && this.trigger.remove();
      } else {
        if ("youtube" == this.typeVideo) this.onYouTubeIframeAPIReady();
        else {
          if ("vimeo" != this.typeVideo) return !0;
          this.onVimeoIframeAPIReady();
        }
        this.trigger?.classList.add("d-none"),
          this.$(".js-media-item").classList.add("d-flex");
      }
      return !0;
    }
  }
  pauseAllVideo(e) {
    document
      .querySelectorAll(
        ".js-product-media-deferred-video:has([data-type='youtube']"
      )
      .forEach((t) => {
        t.player && e !== t.player && t.player?.pauseVideo();
      }),
      document
        .querySelectorAll(
          ".js-product-media-deferred-video:has([data-type='vimeo'])"
        )
        .forEach((t) => {
          t.playerVimeo !== e && t.playerVimeo?.pause();
        }),
      document.querySelectorAll(".js-media-item-video").forEach((t) => {
        t !== e && t.pause();
      });
  }
  isLoaded(t) {
    t ? this.setAttribute("loaded", !0) : this.removeAttribute("loaded");
  }
}
customElements.define("tsa-load-media", TessaLoadMedia);

class LookbookHotspot extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.toggleProductInfo.bind(this));
    this.isMobile = window.innerWidth <= 768;
  }

  connectedCallback() {
    this.productInfo = this.querySelector(".product-info");
    this.checkAndCreateModalBackground();
    window.addEventListener("resize", this.handleResize.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize.bind(this));
    LookbookHotspot.removeModalBackground();
  }

  static createModalBackground() {
    if (!LookbookHotspot.modalBackground) {
      LookbookHotspot.modalBackground = document.createElement("div");
      LookbookHotspot.modalBackground.classList.add(
        "lookbook-modal-background"
      );
      document.body.appendChild(LookbookHotspot.modalBackground);

      LookbookHotspot.modalBackground.addEventListener("click", () => {
        LookbookHotspot.closeAllProductInfo();
      });
    }
  }

  static removeModalBackground() {
    if (
      LookbookHotspot.modalBackground &&
      LookbookHotspot.modalBackground.parentNode
    ) {
      LookbookHotspot.modalBackground.parentNode.removeChild(
        LookbookHotspot.modalBackground
      );
      LookbookHotspot.modalBackground = null;
    }
  }

  checkAndCreateModalBackground() {
    if (this.isMobile) {
      LookbookHotspot.createModalBackground();
    }
  }

  handleResize() {
    const previousIsMobile = this.isMobile;
    this.isMobile = window.innerWidth <= 768;

    if (!previousIsMobile && this.isMobile) {
      LookbookHotspot.closeAllProductInfo();
      LookbookHotspot.createModalBackground();
    }

    if (previousIsMobile && !this.isMobile) {
      LookbookHotspot.closeAllProductInfo();
      LookbookHotspot.removeModalBackground();
    }
  }

  toggleProductInfo() {
    if (this.isMobile) {
      this.openMobileProductInfo();
    } else {
      this.toggleDesktopProductInfo();
    }
  }

  toggleDesktopProductInfo() {
    document
      .querySelectorAll(".lookbook .product-info.active")
      .forEach((info) => {
        if (info !== this.productInfo) {
          info.classList.remove("active");
        }
      });
    this.productInfo.classList.toggle("active");
  }

  openMobileProductInfo() {
    LookbookHotspot.closeAllProductInfo();
    LookbookHotspot.modalContent = this.productInfo.cloneNode(true);
    LookbookHotspot.modalContent.classList.add("active");
    LookbookHotspot.modalContent.classList.add("modal-product-info");

    document.body.appendChild(LookbookHotspot.modalContent);
    LookbookHotspot.modalBackground.classList.add("active");
    document.body.classList.add("modal-open");
  }

  static closeAllProductInfo() {
    document
      .querySelectorAll(".lookbook .product-info.active")
      .forEach((info) => {
        info.classList.remove("active");
      });

    if (
      LookbookHotspot.modalContent &&
      LookbookHotspot.modalContent.parentNode
    ) {
      LookbookHotspot.modalContent.parentNode.removeChild(
        LookbookHotspot.modalContent
      );
      LookbookHotspot.modalContent = null;
    }

    if (LookbookHotspot.modalBackground) {
      LookbookHotspot.modalBackground.classList.remove("active");
    }
    document.body.classList.remove("modal-open");
  }
}

customElements.define("lookbook-hotspot", LookbookHotspot);

class PromoTimer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const targetDateAttr = this.getAttribute("target-date");
    this.targetDate = targetDateAttr
      ? new Date(targetDateAttr).getTime()
      : null;
    this.timerElements = {
      days: this.querySelector("#days"),
      hours: this.querySelector("#hours"),
      minutes: this.querySelector("#minutes"),
      seconds: this.querySelector("#seconds"),
    };
    this.startTimer();
  }

  startTimer() {
    this.updateTimer();
    if (this.targetDate) {
      this.timerInterval = setInterval(() => this.updateTimer(), 1000);
    }
  }

  updateTimer() {
    if (!this.targetDate) {
      this.setAllToZero();
      return;
    }

    const now = new Date().getTime();
    const distance = this.targetDate - now;

    if (distance < 0) {
      clearInterval(this.timerInterval);
      this.setAllToZero();
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.timerElements.days.textContent = days.toString().padStart(2, "0");
    this.timerElements.hours.textContent = hours.toString().padStart(2, "0");
    this.timerElements.minutes.textContent = minutes
      .toString()
      .padStart(2, "0");
    this.timerElements.seconds.textContent = seconds
      .toString()
      .padStart(2, "0");
  }

  setAllToZero() {
    this.timerElements.days.textContent = "00";
    this.timerElements.hours.textContent = "00";
    this.timerElements.minutes.textContent = "00";
    this.timerElements.seconds.textContent = "00";
  }

  disconnectedCallback() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }
}

customElements.define("promo-timer", PromoTimer);

class ColorSwatch extends HTMLElement {
  constructor() {
    super();
    this.option = this.querySelector(".color-swatch__radio");
    this.variantId = this.option.dataset.variantId;
    this.productHandle = this.option.dataset.productHandle;
    this.productCard = this.option.closest(".product-card-wrapper");
    this.form = this.productCard.querySelector(".form");
    this.option.addEventListener("change", this.onSwatchChange.bind(this));
  }

  onSwatchChange() {
    let url = `${window.shopUrl}/products/${this.productHandle}?variant=${this.variantId}&view=colorswatch`;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        this.form.querySelector('input[name="id"]').value = this.variantId;
        this.updatePrice(html);
        this.updateThumbnail(html);
        this.cardBadge(html);
        this.cartButton(html);
      })
      .catch((e) => {
        console.error(e);
      });
  }
  updateThumbnail(html) {
    const destination = this.productCard
      .querySelector(".media")
      .querySelector("img:first-child");
    const source = html.querySelector(".product__media").querySelector("img");
    if (source && destination) {
      destination.src = source.src;
      destination.srcset = source.srcset;
    }
  }

  updatePrice(html) {
    const destination = this.productCard.querySelector(".price");
    const source = html.querySelector(".price");
    if (source && destination) destination.innerHTML = source.innerHTML;
  }
  cardBadge(html) {
    const destination = this.productCard.querySelector(".card__badge");
    const source = html.querySelector(".card__badge");
    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  cartButton(html) {
    const destination = this.productCard.querySelector(".quick-add__submit");
    const source = html.querySelector(".quick-add__submit");
    if (source && destination) destination.innerHTML = source.innerHTML;
    destination.removeAttribute("aria-disabled");
  }
}
customElements.define("color-swatch", ColorSwatch);

class flasSale extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const endDate = this.getAttribute("end-date");
    this.endDate = endDate ? new Date(endDate).getTime() : null;
    this.timerElements = {
      days: this.querySelector("#flash_days"),
      hours: this.querySelector("#flash_hours"),
      minutes: this.querySelector("#flash_minutes"),
      seconds: this.querySelector("#flash_seconds"),
    };
    this.startTimer();
  }

  startTimer() {
    this.updateTimer();
    if (this.endDate) {
      this.timerInterval = setInterval(() => this.updateTimer(), 1000);
    }
  }

  updateTimer() {
    if (!this.endDate) {
      this.setAllToZero();
      return;
    }

    const now = new Date().getTime();
    const distance = this.endDate - now;

    if (distance < 0) {
      clearInterval(this.timerInterval);
      this.setAllToZero();
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.timerElements.days.textContent = days.toString().padStart(2, "0");
    this.timerElements.hours.textContent = hours.toString().padStart(2, "0");
    this.timerElements.minutes.textContent = minutes
      .toString()
      .padStart(2, "0");
    this.timerElements.seconds.textContent = seconds
      .toString()
      .padStart(2, "0");
  }

  setAllToZero() {
    this.timerElements.days.textContent = "00";
    this.timerElements.hours.textContent = "00";
    this.timerElements.minutes.textContent = "00";
    this.timerElements.seconds.textContent = "00";
  }

  disconnectedCallback() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }
}

customElements.define("flash-sale", flasSale);

class CollapsibleContent extends HTMLElement {
  constructor() {
    super();

    this.accordiaonToggle = this.querySelectorAll(".accordion__item-button");
  }
  connectedCallback() {
    this.accordionBody();
  }

  accordionBody(e) {
    this.accordiaonToggle.forEach(function (list) {
      list.addEventListener("click", function (event) {
        let singleFaqItem = list.closest(".accordion__item"),
          singleFaqItemBody = singleFaqItem.querySelector(
            ".accordion__item-content"
          );
        singleFaqItem.addEventListener(
          "transitionend",
          () => {
            trapFocus(singleFaqItem);
          },
          { once: !0 }
        ),
          singleFaqItem.addEventListener("keyup", (evt) => {
            evt.code === "Escape" &&
              (singleFaqItem.classList.remove("active"),
              slideUp(singleFaqItemBody),
              removeTrapFocus(singleFaqItem));
          }),
          singleFaqItem.classList.contains("active")
            ? (singleFaqItem.classList.remove("active"),
              slideUp(singleFaqItemBody))
            : (singleFaqItem.classList.add("active"),
              slideDown(singleFaqItemBody),
              getSiblings(singleFaqItem).forEach(function (list2) {
                let sibllingSingleAccordionBody = list2.querySelector(
                  ".accordion__item-content"
                );
                list2.classList.remove("active"),
                  slideUp(sibllingSingleAccordionBody);
              }));
      });
    });
  }
}

customElements.define("collapsible-content", CollapsibleContent);

class accordionItems extends HTMLElement {
  constructor() {
    super(),
      (this.disclosure = this.querySelector("details")),
      (this.toggle = this.querySelector("summary")),
      (this.panel = this.toggle.nextElementSibling),
      this.init();
  }
  init() {
    window.getComputedStyle(this.panel).transitionDuration !== "0s" &&
      (this.toggle.addEventListener("click", this.handleToggle.bind(this)),
      this.disclosure.addEventListener(
        "transitionend",
        this.handleTransitionEnd.bind(this)
      ));
  }
  handleToggle(evt) {
    evt.preventDefault(), this.disclosure.open ? this.close() : this.open();
  }
  handleTransitionEnd(evt) {
    evt.target === this.panel &&
      (this.disclosure.classList.contains("is-closing") &&
        (this.disclosure.classList.remove("is-closing"),
        (this.disclosure.open = !1)),
      this.panel.removeAttribute("style"));
  }
  addContentHeight() {
    this.panel.style.height = `${this.panel.scrollHeight}px`;
  }
  open() {
    (this.panel.style.height = "0"),
      (this.disclosure.open = !0),
      this.addContentHeight();
  }
  close() {
    this.addContentHeight(),
      this.disclosure.classList.add("is-closing"),
      setTimeout(() => {
        this.panel.style.height = "0";
      });
  }
}
customElements.define("accordion-item", accordionItems);

class navTab extends HTMLElement {
  constructor() {
    super();
    this.tabsToggle = this.querySelectorAll(".nav-tabs li");
    this.nav_tab = this.tab
      ? null
      : Array.from(this.querySelectorAll(".nav-tab"));
    this.tabPanels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.currentNav = this.querySelector(".nav-tabs li.active");
  }
  connectedCallback() {
    if (this.tabsToggle != null && this.tabPanels != null) {
      this.tabClickHandler();
    }
  }

  tabClickHandler() {
    let tablist = this.tabsToggle;
    let tabPanels = this.tabPanels;

    this.tabsToggle.forEach(function (list) {
      list.addEventListener("click", function (e) {
        tablist.forEach(function (label, index) {
          label.classList.remove("active");
        });

        [].forEach.call(tabPanels, function (pane, index) {
          pane.classList.remove("active");
          pane.setAttribute("style", "");
        });
        e.currentTarget.classList.add("active");
        const { id } = e.currentTarget.querySelector(".nav-tab");

        const currentTab = tabPanels.find(
          (panel) => panel.getAttribute("aria-labelledby") === id
        );
        currentTab.parentNode.classList.add("active");
        currentTab.classList.add("active");
      });
    });
  }
}
customElements.define("nav-tab", navTab);

var rating_target = document.querySelector(".product-rating .rating");

if (rating_target != null) {
  rating_target.addEventListener("click", () => {
    smoothScrollTo('[data-block-handle="review_widget"]');
  });
}

var more_info = document.querySelector(".more-info-link");
if (more_info != null) {
  more_info.addEventListener("click", function () {
    var target = this.dataset.scrollTarget;
    if (target != null) {
      smoothScrollTo("[id=" + target + "]");
    }
  });
}

function smoothScrollTo(target, headerSpacing = 0, behavior = "smooth") {
  if (target != null) {
    const elementPosition =
      document.querySelector(target).getBoundingClientRect().top +
      window.scrollY;
    window.scroll({
      behavior,
      top: elementPosition - headerSpacing,
    });
  }
}

class navSwiper extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.main_slider = this.querySelector(".main-slider");
    this.nav_slider = this.querySelector(".nav-slider");
    if (!this.nav_slider) return;
    const resizeObserver = new ResizeObserver((entries) => this.init());
    resizeObserver.observe(this.nav_slider);
  }
  init() {
    let nextT = this.querySelector(".swiper-button-next");
    let prevT = this.querySelector(".swiper-button-prev");

    if( this.nav_slider != null ){


    this.nav_slider = new Swiper(this.nav_slider, {
      spaceBetween: 0,
      slidesPerView: 2,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: nextT,
        prevEl: prevT,
      },
      breakpoints: {
        1920: {
          slidesPerView: 3,
        },
        767: {
          slidesPerView: 3,
        },
      },
    });

    // console.log("Tress", this.main_slider.dataset.autoplay);

    this.main_slider = new Swiper(this.main_slider, {
      effect: "fade",
      autoHeight: true,
      allowTouchMove: false,
      thumbs: {
        swiper: this.nav_slider,
      },
    });

  }
  }
}
customElements.define("nav-slider", navSwiper);
